import Vue from 'vue'
import App from './App.vue'
import router from './router'

// web3
//import Web3 from 'web3'

// vue2 google maps package
import * as VueGoogleMaps from "vue2-google-maps" // Import package
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyADlrnhMJmtgQZkNOSHUkbguzXVLHGGt6g",
    libraries: "places"
  }
});

// font awesome icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHatWizard } from '@fortawesome/free-solid-svg-icons'
import { faVectorSquare } from '@fortawesome/free-solid-svg-icons'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { faCube } from '@fortawesome/free-solid-svg-icons'
import { faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { faFileImport } from '@fortawesome/free-solid-svg-icons'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faFileContract } from '@fortawesome/free-solid-svg-icons'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { faBell } from '@fortawesome/free-regular-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { faMicrochip } from '@fortawesome/free-solid-svg-icons'
import { faTemperatureLow } from '@fortawesome/free-solid-svg-icons'
import { faTemperatureHigh } from '@fortawesome/free-solid-svg-icons'
import { faRobot } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faCompress } from '@fortawesome/free-solid-svg-icons'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { faPause } from '@fortawesome/free-solid-svg-icons'
import { faDiceD6 } from '@fortawesome/free-solid-svg-icons'
import { faEthereum } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

library.add(faHatWizard)
library.add(faVectorSquare)
library.add(faMap)
library.add(faCube)
library.add(faFileSignature)
library.add(faPlus)
library.add(faEllipsisV)
library.add(faFileImport)
library.add(faCaretDown)
library.add(faCaretUp)
library.add(faMinus)
library.add(faChevronDown)
library.add(faFileContract)
library.add(faCloudUploadAlt)
library.add(faExclamationCircle)
library.add(faBell)
library.add(faUser)
library.add(faMicrochip)
library.add(faTemperatureLow)
library.add(faTemperatureHigh)
library.add(faRobot)
library.add(faExpand)
library.add(faCompress)
library.add(faPlay)
library.add(faPause)
library.add(faDiceD6)
library.add(faEthereum)
library.add(faLink)
library.add(faSlidersH)
library.add(faCircleXmark)
library.add(faCheck)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Bootstrap Vue package
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';

// @nasaworldwind/worldwind
import '@nasaworldwind/worldwind'

// animate.css
import 'animate.css';

// axios package
import axios from 'axios';
Vue.prototype.$http = axios;

// moment.js
Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// kendo UI for vue
import '@progress/kendo-theme-bootstrap'

// a frame
import 'aframe'

import { Grid } from '@progress/kendo-vue-grid'

Vue.component('Grid', Grid);

Vue.config.productionTip = false

/* Import and initialise the charting tool */
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import HighchartsMore from 'highcharts/highcharts-more';
import exportingInit from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import HighchartsBoost from "highcharts/modules/boost";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";

// Import order is important !
stockInit(Highcharts)
HighchartsMore(Highcharts);
exportingInit(Highcharts);
exportData(Highcharts);
HighchartsBoost(Highcharts);
HighchartsSolidGauge(Highcharts);
Vue.use(HighchartsVue)

/* Import and install the barcode reader */
import { StreamBarcodeReader } from "vue-barcode-reader";
Vue.use(StreamBarcodeReader);

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
